export default __webpack_public_path__ + "static/media/more.a49346bd.svg";